import * as Types from '../../generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type GetOptionsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetOptionsQuery = { type_enum: Array<{ value: string }> };

export type GetWaitingListStatsQueryVariables = Types.Exact<{
  where: Types.Waiting_List_Bool_Exp;
}>;


export type GetWaitingListStatsQuery = { all: { aggregate?: { assigned_hours?: { total?: any | null } | null } | null }, go: { aggregate?: { assigned_hours?: { total?: any | null } | null } | null }, isb: { aggregate?: { assigned_hours?: { total?: any | null } | null } | null }, ash: { aggregate?: { assigned_hours?: { total?: any | null } | null } | null }, bor: { aggregate?: { assigned_hours?: { total?: any | null } | null } | null }, po: { aggregate?: { assigned_hours?: { total?: any | null } | null } | null }, reg: { aggregate?: { assigned_hours?: { total?: any | null } | null } | null }, ggo: { aggregate?: { assigned_hours?: { total?: any | null } | null } | null }, allF: { aggregate?: { filled_hours?: { designated_hours?: any | null } | null } | null }, goF: { aggregate?: { filled_hours?: { designated_hours?: any | null } | null } | null }, isbF: { aggregate?: { filled_hours?: { designated_hours?: any | null } | null } | null }, ashF: { aggregate?: { filled_hours?: { designated_hours?: any | null } | null } | null }, borF: { aggregate?: { filled_hours?: { designated_hours?: any | null } | null } | null }, poF: { aggregate?: { filled_hours?: { designated_hours?: any | null } | null } | null }, regF: { aggregate?: { filled_hours?: { designated_hours?: any | null } | null } | null }, ggoF: { aggregate?: { filled_hours?: { designated_hours?: any | null } | null } | null } };

export type GetWaitingListStatsRegionQueryVariables = Types.Exact<{
  where: Types.Waiting_List_Bool_Exp;
}>;


export type GetWaitingListStatsRegionQuery = { all: { aggregate?: { assigned_hours?: { total?: any | null } | null } | null }, mo: { aggregate?: { assigned_hours?: { total?: any | null } | null } | null }, ah: { aggregate?: { assigned_hours?: { total?: any | null } | null } | null }, nv: { aggregate?: { assigned_hours?: { total?: any | null } | null } | null }, tw: { aggregate?: { assigned_hours?: { total?: any | null } | null } | null }, zd: { aggregate?: { assigned_hours?: { total?: any | null } | null } | null }, nmd: { aggregate?: { assigned_hours?: { total?: any | null } | null } | null }, fv: { aggregate?: { assigned_hours?: { total?: any | null } | null } | null }, allF: { aggregate?: { filled_hours?: { designated_hours?: any | null } | null } | null }, moF: { aggregate?: { filled_hours?: { designated_hours?: any | null } | null } | null }, ahF: { aggregate?: { filled_hours?: { designated_hours?: any | null } | null } | null }, nvF: { aggregate?: { filled_hours?: { designated_hours?: any | null } | null } | null }, twF: { aggregate?: { filled_hours?: { designated_hours?: any | null } | null } | null }, zdF: { aggregate?: { filled_hours?: { designated_hours?: any | null } | null } | null }, nmdF: { aggregate?: { filled_hours?: { designated_hours?: any | null } | null } | null }, fvF: { aggregate?: { filled_hours?: { designated_hours?: any | null } | null } | null } };

export type GetUserQueryVariables = Types.Exact<{
  where: Types.Auth_User_Bool_Exp;
  order_by: Array<Types.Auth_User_Order_By> | Types.Auth_User_Order_By;
}>;


export type GetUserQuery = { auth_user: Array<{ name?: string | null, id: any, plannable_contract_hours?: number | null, team?: { name?: string | null } | null, user_waiting_list_items_aggregate: { aggregate?: { sum?: { designated_hours?: any | null } | null } | null }, plannedHours: { aggregate?: { sum?: { weekly_hours?: any | null } | null } | null } }> };

export type GetRelatedCaretakersQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetRelatedCaretakersQuery = { auth_user: Array<{ id: any, name?: string | null, role?: Types.Auth_User_Role_Enum_Enum | null }> };

export type GetAllUsers2QueryVariables = Types.Exact<{
  destination: Types.Scalars['String'];
  where: Types.Auth_User_Bool_Exp;
}>;


export type GetAllUsers2Query = { auth_user: Array<{ id: any, free?: any | null, free_with_la?: any | null, name?: string | null, city?: string | null, ash?: boolean | null, isb?: boolean | null, go?: boolean | null, po?: boolean | null, planner_comment?: string | null, comment?: string | null, plannable_contract_hours?: number | null, even?: boolean | null, labels: Array<{ label: { title: string, id: number, color?: string | null, type: Types.Label_Type_Enum_Enum } }>, team?: { name?: string | null, regio_text?: string | null, id: number } | null, user_waiting_list_items_aggregate: { aggregate?: { sum?: { designated_hours?: any | null } | null } | null }, plannedHours: { aggregate?: { sum?: { weekly_hours?: any | null } | null } | null }, caseLoadsByUserId: Array<{ iz?: string | null, k?: string | null, la?: string | null, isb: boolean, client: { municipality_id?: number | null } }>, data_auth_user_last_free_date?: { date: any } | null, room_available?: Array<{ la?: string | null, end_date?: any | null, upcoming_weekly_hours?: any | null, upcoming_start_date?: any | null }> | null }>, getLocationData?: Array<{ route_string: string, time_in_minutes: any } | null> | null };

export type WaitingListByPkQueryVariables = Types.Exact<{
  id: Types.Scalars['Int'];
}>;


export type WaitingListByPkQuery = { waiting_list_by_pk?: { id: number, referrer?: string | null, assigned_hours?: any | null, client_last_name?: string | null, client_initials?: string | null, client_sex: string, ons_identification_no?: string | null, region?: string | null, client_name: string, birth_date?: any | null, address?: string | null, township?: string | null, hulpverlener_id?: any | null, priority_bool: boolean, weekend_str?: string | null, weekend: boolean, description?: string | null, info?: string | null, received_on: any, priority?: any | null, priority_description?: string | null, on_hold?: any | null, on_hold_bool: boolean, on_hold_description?: string | null, created_at?: any | null, updated_at?: any | null, created_by?: any | null, updated_by?: any | null, archived: boolean, type: Types.Type_Enum_Enum, completed: boolean, client_id?: number | null, ons_client_id?: number | null, process_date?: any | null, vacation_date?: any | null, registration_type: string, municipality_id?: number | null, labels: Array<{ label: { color?: string | null, id: number, title: string, type: Types.Label_Type_Enum_Enum } }> } | null, compareClientToOns?: { changed?: boolean | null, has_bsn?: boolean | null, client_information?: { birth_date?: string | null, bsn?: string | null, client_initials?: string | null, client_last_name?: string | null, client_name?: string | null, township?: string | null, municipality_id?: number | null } | null } | null };

export type GetAllWaitinglistIncompleteQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetAllWaitinglistIncompleteQuery = { waiting_list_incomplete: Array<{ added_birthdate: string, added_bsn: string, added_fullname: string, added_hours: string, added_referrer: string, added_township: string, added_date: string, added_questions: string, added_problem_info: string, added_caretaker_history: string, added_family_situation: string, comment: string, correct_birthdate: string, correct_bsn: string, correct_description: string, correct_first_name: string, correct_hours: string, correct_info: string, correct_initials: string, correct_last_name: string, correct_referrer: string, correct_township: string, id: any }> };

export type GetWaitingListStatsPerDayQueryVariables = Types.Exact<{
  from: Types.Scalars['timestamptz'];
  to: Types.Scalars['timestamptz'];
}>;


export type GetWaitingListStatsPerDayQuery = { total_per_day: { aggregate?: { count: number } | null }, total_per_day_per_type_ash: { aggregate?: { count: number } | null }, total_per_day_per_type_go: { aggregate?: { count: number } | null }, total_per_day_per_type_po: { aggregate?: { count: number } | null }, total_per_day_per_type_ggo: { aggregate?: { count: number } | null }, total_per_day_per_type_reg: { aggregate?: { count: number } | null }, total_per_day_per_type_bor: { aggregate?: { count: number } | null }, total_per_day_per_type_isb: { aggregate?: { count: number } | null }, total_per_day_per_region_ah: { aggregate?: { count: number } | null }, total_per_day_per_region_zd: { aggregate?: { count: number } | null }, total_per_day_per_region_nv: { aggregate?: { count: number } | null }, total_per_day_per_region_tw: { aggregate?: { count: number } | null }, total_per_day_per_region_mo: { aggregate?: { count: number } | null }, total_per_day_per_region_nmd: { aggregate?: { count: number } | null }, total_per_day_per_region_fv: { aggregate?: { count: number } | null }, total: { aggregate?: { count: number } | null }, total_per_type_ash: { aggregate?: { count: number } | null }, total_per_type_go: { aggregate?: { count: number } | null }, total_per_type_po: { aggregate?: { count: number } | null }, total_per_type_ggo: { aggregate?: { count: number } | null }, total_per_type_reg: { aggregate?: { count: number } | null }, total_per_type_bor: { aggregate?: { count: number } | null }, total_per_type_isb: { aggregate?: { count: number } | null }, total_per_region_ah: { aggregate?: { count: number } | null }, total_per_region_zd: { aggregate?: { count: number } | null }, total_per_region_nv: { aggregate?: { count: number } | null }, total_per_region_tw: { aggregate?: { count: number } | null }, total_per_region_mo: { aggregate?: { count: number } | null } };

export type SeeAllClientsIdsInWaitingListQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type SeeAllClientsIdsInWaitingListQuery = { waiting_list: Array<{ client_id?: number | null, waiting_list_waiting_list_items: Array<{ id: any, caseload?: { client_id: number, user_id: any } | null }> }> };


export const GetOptionsDocument = gql`
    query getOptions {
  type_enum(order_by: {value: asc}) {
    value
  }
}
    `;

/**
 * __useGetOptionsQuery__
 *
 * To run a query within a React component, call `useGetOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetOptionsQuery, GetOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetOptionsQuery, GetOptionsQueryVariables>(GetOptionsDocument, options);
      }
export function useGetOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetOptionsQuery, GetOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetOptionsQuery, GetOptionsQueryVariables>(GetOptionsDocument, options);
        }
export type GetOptionsQueryHookResult = ReturnType<typeof useGetOptionsQuery>;
export type GetOptionsLazyQueryHookResult = ReturnType<typeof useGetOptionsLazyQuery>;
export type GetOptionsQueryResult = Apollo.QueryResult<GetOptionsQuery, GetOptionsQueryVariables>;
export const GetWaitingListStatsDocument = gql`
    query GetWaitingListStats($where: waiting_list_bool_exp!) {
  all: waiting_list_aggregate(where: {_and: [{archived: {_eq: false}}, $where]}) {
    aggregate {
      assigned_hours: sum {
        total: assigned_hours
      }
    }
  }
  go: waiting_list_aggregate(
    where: {_and: [{type: {_eq: go}}, {archived: {_eq: false}}, $where]}
  ) {
    aggregate {
      assigned_hours: sum {
        total: assigned_hours
      }
    }
  }
  isb: waiting_list_aggregate(
    where: {_and: [{type: {_eq: isb}}, {archived: {_eq: false}}, $where]}
  ) {
    aggregate {
      assigned_hours: sum {
        total: assigned_hours
      }
    }
  }
  ash: waiting_list_aggregate(
    where: {_and: [{type: {_eq: ash}}, {archived: {_eq: false}}, $where]}
  ) {
    aggregate {
      assigned_hours: sum {
        total: assigned_hours
      }
    }
  }
  bor: waiting_list_aggregate(
    where: {_and: [{type: {_eq: bor}}, {archived: {_eq: false}}, $where]}
  ) {
    aggregate {
      assigned_hours: sum {
        total: assigned_hours
      }
    }
  }
  po: waiting_list_aggregate(
    where: {_and: [{type: {_eq: po}}, {archived: {_eq: false}}, $where]}
  ) {
    aggregate {
      assigned_hours: sum {
        total: assigned_hours
      }
    }
  }
  reg: waiting_list_aggregate(
    where: {_and: [{type: {_eq: reg}}, {archived: {_eq: false}}, $where]}
  ) {
    aggregate {
      assigned_hours: sum {
        total: assigned_hours
      }
    }
  }
  ggo: waiting_list_aggregate(
    where: {_and: [{type: {_eq: ggo}}, {archived: {_eq: false}}, $where]}
  ) {
    aggregate {
      assigned_hours: sum {
        total: assigned_hours
      }
    }
  }
  allF: waiting_list_item_aggregate(
    where: {waiting_list: {_and: [{archived: {_eq: false}}, $where]}}
  ) {
    aggregate {
      filled_hours: sum {
        designated_hours
      }
    }
  }
  goF: waiting_list_item_aggregate(
    where: {waiting_list: {_and: [{type: {_eq: go}}, {archived: {_eq: false}}, $where]}}
  ) {
    aggregate {
      filled_hours: sum {
        designated_hours
      }
    }
  }
  isbF: waiting_list_item_aggregate(
    where: {waiting_list: {_and: [{type: {_eq: isb}}, {archived: {_eq: false}}, $where]}}
  ) {
    aggregate {
      filled_hours: sum {
        designated_hours
      }
    }
  }
  ashF: waiting_list_item_aggregate(
    where: {waiting_list: {_and: [{type: {_eq: ash}}, {archived: {_eq: false}}, $where]}}
  ) {
    aggregate {
      filled_hours: sum {
        designated_hours
      }
    }
  }
  borF: waiting_list_item_aggregate(
    where: {waiting_list: {_and: [{type: {_eq: bor}}, {archived: {_eq: false}}, $where]}}
  ) {
    aggregate {
      filled_hours: sum {
        designated_hours
      }
    }
  }
  poF: waiting_list_item_aggregate(
    where: {waiting_list: {_and: [{type: {_eq: po}}, {archived: {_eq: false}}, $where]}}
  ) {
    aggregate {
      filled_hours: sum {
        designated_hours
      }
    }
  }
  regF: waiting_list_item_aggregate(
    where: {waiting_list: {_and: [{type: {_eq: reg}}, {archived: {_eq: false}}, $where]}}
  ) {
    aggregate {
      filled_hours: sum {
        designated_hours
      }
    }
  }
  ggoF: waiting_list_item_aggregate(
    where: {waiting_list: {_and: [{type: {_eq: ggo}}, {archived: {_eq: false}}, $where]}}
  ) {
    aggregate {
      filled_hours: sum {
        designated_hours
      }
    }
  }
}
    `;

/**
 * __useGetWaitingListStatsQuery__
 *
 * To run a query within a React component, call `useGetWaitingListStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWaitingListStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWaitingListStatsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetWaitingListStatsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetWaitingListStatsQuery, GetWaitingListStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWaitingListStatsQuery, GetWaitingListStatsQueryVariables>(GetWaitingListStatsDocument, options);
      }
export function useGetWaitingListStatsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetWaitingListStatsQuery, GetWaitingListStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWaitingListStatsQuery, GetWaitingListStatsQueryVariables>(GetWaitingListStatsDocument, options);
        }
export type GetWaitingListStatsQueryHookResult = ReturnType<typeof useGetWaitingListStatsQuery>;
export type GetWaitingListStatsLazyQueryHookResult = ReturnType<typeof useGetWaitingListStatsLazyQuery>;
export type GetWaitingListStatsQueryResult = Apollo.QueryResult<GetWaitingListStatsQuery, GetWaitingListStatsQueryVariables>;
export const GetWaitingListStatsRegionDocument = gql`
    query GetWaitingListStatsRegion($where: waiting_list_bool_exp!) {
  all: waiting_list_aggregate(where: {_and: [{archived: {_eq: false}}, $where]}) {
    aggregate {
      assigned_hours: sum {
        total: assigned_hours
      }
    }
  }
  mo: waiting_list_aggregate(
    where: {_and: [{region: {_eq: "MO"}}, {archived: {_eq: false}}, $where]}
  ) {
    aggregate {
      assigned_hours: sum {
        total: assigned_hours
      }
    }
  }
  ah: waiting_list_aggregate(
    where: {_and: [{region: {_eq: "AH"}}, {archived: {_eq: false}}, $where]}
  ) {
    aggregate {
      assigned_hours: sum {
        total: assigned_hours
      }
    }
  }
  nv: waiting_list_aggregate(
    where: {_and: [{region: {_eq: "NV"}}, {archived: {_eq: false}}, $where]}
  ) {
    aggregate {
      assigned_hours: sum {
        total: assigned_hours
      }
    }
  }
  tw: waiting_list_aggregate(
    where: {_and: [{region: {_eq: "TW"}}, {archived: {_eq: false}}, $where]}
  ) {
    aggregate {
      assigned_hours: sum {
        total: assigned_hours
      }
    }
  }
  zd: waiting_list_aggregate(
    where: {_and: [{region: {_eq: "ZD"}}, {archived: {_eq: false}}, $where]}
  ) {
    aggregate {
      assigned_hours: sum {
        total: assigned_hours
      }
    }
  }
  nmd: waiting_list_aggregate(
    where: {_and: [{region: {_eq: "NMD"}}, {archived: {_eq: false}}, $where]}
  ) {
    aggregate {
      assigned_hours: sum {
        total: assigned_hours
      }
    }
  }
  fv: waiting_list_aggregate(
    where: {_and: [{region: {_eq: "FV"}}, {archived: {_eq: false}}, $where]}
  ) {
    aggregate {
      assigned_hours: sum {
        total: assigned_hours
      }
    }
  }
  allF: waiting_list_item_aggregate(
    where: {waiting_list: {_and: [{archived: {_eq: false}}, $where]}}
  ) {
    aggregate {
      filled_hours: sum {
        designated_hours
      }
    }
  }
  moF: waiting_list_item_aggregate(
    where: {waiting_list: {_and: [{region: {_eq: "MO"}}, {archived: {_eq: false}}, $where]}}
  ) {
    aggregate {
      filled_hours: sum {
        designated_hours
      }
    }
  }
  ahF: waiting_list_item_aggregate(
    where: {waiting_list: {_and: [{region: {_eq: "AH"}}, {archived: {_eq: false}}, $where]}}
  ) {
    aggregate {
      filled_hours: sum {
        designated_hours
      }
    }
  }
  nvF: waiting_list_item_aggregate(
    where: {waiting_list: {_and: [{region: {_eq: "NV"}}, {archived: {_eq: false}}, $where]}}
  ) {
    aggregate {
      filled_hours: sum {
        designated_hours
      }
    }
  }
  twF: waiting_list_item_aggregate(
    where: {waiting_list: {_and: [{region: {_eq: "TW"}}, {archived: {_eq: false}}, $where]}}
  ) {
    aggregate {
      filled_hours: sum {
        designated_hours
      }
    }
  }
  zdF: waiting_list_item_aggregate(
    where: {waiting_list: {_and: [{region: {_eq: "ZD"}}, {archived: {_eq: false}}, $where]}}
  ) {
    aggregate {
      filled_hours: sum {
        designated_hours
      }
    }
  }
  nmdF: waiting_list_item_aggregate(
    where: {waiting_list: {_and: [{region: {_eq: "NMD"}}, {archived: {_eq: false}}, $where]}}
  ) {
    aggregate {
      filled_hours: sum {
        designated_hours
      }
    }
  }
  fvF: waiting_list_item_aggregate(
    where: {waiting_list: {_and: [{region: {_eq: "FV"}}, {archived: {_eq: false}}, $where]}}
  ) {
    aggregate {
      filled_hours: sum {
        designated_hours
      }
    }
  }
}
    `;

/**
 * __useGetWaitingListStatsRegionQuery__
 *
 * To run a query within a React component, call `useGetWaitingListStatsRegionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWaitingListStatsRegionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWaitingListStatsRegionQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetWaitingListStatsRegionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetWaitingListStatsRegionQuery, GetWaitingListStatsRegionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWaitingListStatsRegionQuery, GetWaitingListStatsRegionQueryVariables>(GetWaitingListStatsRegionDocument, options);
      }
export function useGetWaitingListStatsRegionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetWaitingListStatsRegionQuery, GetWaitingListStatsRegionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWaitingListStatsRegionQuery, GetWaitingListStatsRegionQueryVariables>(GetWaitingListStatsRegionDocument, options);
        }
export type GetWaitingListStatsRegionQueryHookResult = ReturnType<typeof useGetWaitingListStatsRegionQuery>;
export type GetWaitingListStatsRegionLazyQueryHookResult = ReturnType<typeof useGetWaitingListStatsRegionLazyQuery>;
export type GetWaitingListStatsRegionQueryResult = Apollo.QueryResult<GetWaitingListStatsRegionQuery, GetWaitingListStatsRegionQueryVariables>;
export const GetUserDocument = gql`
    query GetUser($where: auth_user_bool_exp!, $order_by: [auth_user_order_by!]!) {
  auth_user(where: $where, order_by: $order_by) {
    name
    id
    team {
      name
    }
    plannable_contract_hours
    user_waiting_list_items_aggregate(where: {completed: {_eq: false}}) {
      aggregate {
        sum {
          designated_hours
        }
      }
    }
    plannedHours: caseLoadsByUserId_aggregate(
      where: {_or: [{end_date: {_gte: "now()"}}, {end_date: {_is_null: true}}]}
    ) {
      aggregate {
        sum {
          weekly_hours
        }
      }
    }
  }
}
    `;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      where: // value for 'where'
 *      order_by: // value for 'order_by'
 *   },
 * });
 */
export function useGetUserQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const GetRelatedCaretakersDocument = gql`
    query GetRelatedCaretakers {
  auth_user(
    order_by: {role: desc, name: asc}
    where: {_or: [{role: {_in: [team_coordinator, hulpverlener]}}]}
  ) {
    id
    name
    role
  }
}
    `;

/**
 * __useGetRelatedCaretakersQuery__
 *
 * To run a query within a React component, call `useGetRelatedCaretakersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRelatedCaretakersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRelatedCaretakersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRelatedCaretakersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRelatedCaretakersQuery, GetRelatedCaretakersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetRelatedCaretakersQuery, GetRelatedCaretakersQueryVariables>(GetRelatedCaretakersDocument, options);
      }
export function useGetRelatedCaretakersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRelatedCaretakersQuery, GetRelatedCaretakersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetRelatedCaretakersQuery, GetRelatedCaretakersQueryVariables>(GetRelatedCaretakersDocument, options);
        }
export type GetRelatedCaretakersQueryHookResult = ReturnType<typeof useGetRelatedCaretakersQuery>;
export type GetRelatedCaretakersLazyQueryHookResult = ReturnType<typeof useGetRelatedCaretakersLazyQuery>;
export type GetRelatedCaretakersQueryResult = Apollo.QueryResult<GetRelatedCaretakersQuery, GetRelatedCaretakersQueryVariables>;
export const GetAllUsers2Document = gql`
    query getAllUsers2($destination: String!, $where: auth_user_bool_exp!) {
  auth_user(where: $where) {
    id
    free
    free_with_la
    name
    city
    ash
    isb
    go
    po
    labels {
      label {
        title
        id
        color
        type
      }
    }
    planner_comment
    comment
    team {
      name
      regio_text
      id
    }
    plannable_contract_hours
    isb
    user_waiting_list_items_aggregate(where: {completed: {_eq: false}}) {
      aggregate {
        sum {
          designated_hours
        }
      }
    }
    plannedHours: caseLoadsByUserId_aggregate(
      where: {_or: [{end_date: {_gte: "now()"}}, {end_date: {_is_null: true}}]}
    ) {
      aggregate {
        sum {
          weekly_hours
        }
      }
    }
    caseLoadsByUserId {
      iz
      k
      la
      isb
      client {
        municipality_id
      }
    }
    even
    data_auth_user_last_free_date {
      date
    }
    room_available(where: {la: {_gt: "0.0"}}) {
      la
      end_date
      upcoming_weekly_hours
      upcoming_start_date
    }
  }
  getLocationData(destination: $destination) {
    route_string
    time_in_minutes
  }
}
    `;

/**
 * __useGetAllUsers2Query__
 *
 * To run a query within a React component, call `useGetAllUsers2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetAllUsers2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllUsers2Query({
 *   variables: {
 *      destination: // value for 'destination'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetAllUsers2Query(baseOptions: ApolloReactHooks.QueryHookOptions<GetAllUsers2Query, GetAllUsers2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAllUsers2Query, GetAllUsers2QueryVariables>(GetAllUsers2Document, options);
      }
export function useGetAllUsers2LazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAllUsers2Query, GetAllUsers2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAllUsers2Query, GetAllUsers2QueryVariables>(GetAllUsers2Document, options);
        }
export type GetAllUsers2QueryHookResult = ReturnType<typeof useGetAllUsers2Query>;
export type GetAllUsers2LazyQueryHookResult = ReturnType<typeof useGetAllUsers2LazyQuery>;
export type GetAllUsers2QueryResult = Apollo.QueryResult<GetAllUsers2Query, GetAllUsers2QueryVariables>;
export const WaitingListByPkDocument = gql`
    query waitingListByPk($id: Int!) {
  waiting_list_by_pk(id: $id) {
    id
    referrer
    assigned_hours
    client_last_name
    client_initials
    client_sex
    ons_identification_no
    region
    client_name
    birth_date
    address
    township
    hulpverlener_id
    priority_bool
    weekend_str
    weekend
    description
    info
    received_on
    priority
    priority_description
    on_hold
    on_hold_bool
    on_hold_description
    created_at
    updated_at
    created_by
    updated_by
    archived
    type
    completed
    client_id
    ons_client_id
    process_date
    vacation_date
    labels {
      label {
        color
        id
        title
        type
      }
    }
    registration_type
    municipality_id
  }
  compareClientToOns(waiting_list_id: $id) {
    changed
    has_bsn
    client_information {
      birth_date
      bsn
      client_initials
      client_last_name
      client_name
      township
      municipality_id
    }
  }
}
    `;

/**
 * __useWaitingListByPkQuery__
 *
 * To run a query within a React component, call `useWaitingListByPkQuery` and pass it any options that fit your needs.
 * When your component renders, `useWaitingListByPkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWaitingListByPkQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWaitingListByPkQuery(baseOptions: ApolloReactHooks.QueryHookOptions<WaitingListByPkQuery, WaitingListByPkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WaitingListByPkQuery, WaitingListByPkQueryVariables>(WaitingListByPkDocument, options);
      }
export function useWaitingListByPkLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WaitingListByPkQuery, WaitingListByPkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WaitingListByPkQuery, WaitingListByPkQueryVariables>(WaitingListByPkDocument, options);
        }
export type WaitingListByPkQueryHookResult = ReturnType<typeof useWaitingListByPkQuery>;
export type WaitingListByPkLazyQueryHookResult = ReturnType<typeof useWaitingListByPkLazyQuery>;
export type WaitingListByPkQueryResult = Apollo.QueryResult<WaitingListByPkQuery, WaitingListByPkQueryVariables>;
export const GetAllWaitinglistIncompleteDocument = gql`
    query GetAllWaitinglistIncomplete {
  waiting_list_incomplete {
    added_birthdate
    added_bsn
    added_fullname
    added_hours
    added_referrer
    added_township
    added_date
    added_questions
    added_problem_info
    added_caretaker_history
    added_family_situation
    comment
    correct_birthdate
    correct_bsn
    correct_description
    correct_first_name
    correct_hours
    correct_info
    correct_initials
    correct_last_name
    correct_referrer
    correct_township
    id
  }
}
    `;

/**
 * __useGetAllWaitinglistIncompleteQuery__
 *
 * To run a query within a React component, call `useGetAllWaitinglistIncompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllWaitinglistIncompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllWaitinglistIncompleteQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllWaitinglistIncompleteQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAllWaitinglistIncompleteQuery, GetAllWaitinglistIncompleteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAllWaitinglistIncompleteQuery, GetAllWaitinglistIncompleteQueryVariables>(GetAllWaitinglistIncompleteDocument, options);
      }
export function useGetAllWaitinglistIncompleteLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAllWaitinglistIncompleteQuery, GetAllWaitinglistIncompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAllWaitinglistIncompleteQuery, GetAllWaitinglistIncompleteQueryVariables>(GetAllWaitinglistIncompleteDocument, options);
        }
export type GetAllWaitinglistIncompleteQueryHookResult = ReturnType<typeof useGetAllWaitinglistIncompleteQuery>;
export type GetAllWaitinglistIncompleteLazyQueryHookResult = ReturnType<typeof useGetAllWaitinglistIncompleteLazyQuery>;
export type GetAllWaitinglistIncompleteQueryResult = Apollo.QueryResult<GetAllWaitinglistIncompleteQuery, GetAllWaitinglistIncompleteQueryVariables>;
export const GetWaitingListStatsPerDayDocument = gql`
    query GetWaitingListStatsPerDay($from: timestamptz!, $to: timestamptz!) {
  total_per_day: waiting_list_aggregate(
    where: {created_at: {_gte: $from, _lte: $to}}
  ) {
    aggregate {
      count
    }
  }
  total_per_day_per_type_ash: waiting_list_aggregate(
    where: {created_at: {_gte: $from, _lte: $to}, type: {_eq: ash}}
  ) {
    aggregate {
      count
    }
  }
  total_per_day_per_type_go: waiting_list_aggregate(
    where: {created_at: {_gte: $from, _lte: $to}, type: {_eq: go}}
  ) {
    aggregate {
      count
    }
  }
  total_per_day_per_type_po: waiting_list_aggregate(
    where: {created_at: {_gte: $from, _lte: $to}, type: {_eq: po}}
  ) {
    aggregate {
      count
    }
  }
  total_per_day_per_type_ggo: waiting_list_aggregate(
    where: {created_at: {_gte: $from, _lte: $to}, type: {_eq: ggo}}
  ) {
    aggregate {
      count
    }
  }
  total_per_day_per_type_reg: waiting_list_aggregate(
    where: {created_at: {_gte: $from, _lte: $to}, type: {_eq: reg}}
  ) {
    aggregate {
      count
    }
  }
  total_per_day_per_type_bor: waiting_list_aggregate(
    where: {created_at: {_gte: $from, _lte: $to}, type: {_eq: bor}}
  ) {
    aggregate {
      count
    }
  }
  total_per_day_per_type_isb: waiting_list_aggregate(
    where: {created_at: {_gte: $from, _lte: $to}, type: {_eq: isb}}
  ) {
    aggregate {
      count
    }
  }
  total_per_day_per_region_ah: waiting_list_aggregate(
    where: {created_at: {_gte: $from, _lte: $to}, region: {_eq: "AH"}}
  ) {
    aggregate {
      count
    }
  }
  total_per_day_per_region_zd: waiting_list_aggregate(
    where: {created_at: {_gte: $from, _lte: $to}, region: {_eq: "ZD"}}
  ) {
    aggregate {
      count
    }
  }
  total_per_day_per_region_nv: waiting_list_aggregate(
    where: {created_at: {_gte: $from, _lte: $to}, region: {_eq: "NV"}}
  ) {
    aggregate {
      count
    }
  }
  total_per_day_per_region_tw: waiting_list_aggregate(
    where: {created_at: {_gte: $from, _lte: $to}, region: {_eq: "TW"}}
  ) {
    aggregate {
      count
    }
  }
  total_per_day_per_region_mo: waiting_list_aggregate(
    where: {created_at: {_gte: $from, _lte: $to}, region: {_eq: "MO"}}
  ) {
    aggregate {
      count
    }
  }
  total_per_day_per_region_nmd: waiting_list_aggregate(
    where: {created_at: {_gte: $from, _lte: $to}, region: {_eq: "NMD"}}
  ) {
    aggregate {
      count
    }
  }
  total_per_day_per_region_fv: waiting_list_aggregate(
    where: {created_at: {_gte: $from, _lte: $to}, region: {_eq: "FV"}}
  ) {
    aggregate {
      count
    }
  }
  total: waiting_list_aggregate {
    aggregate {
      count
    }
  }
  total_per_type_ash: waiting_list_aggregate(where: {type: {_eq: ash}}) {
    aggregate {
      count
    }
  }
  total_per_type_go: waiting_list_aggregate(where: {type: {_eq: go}}) {
    aggregate {
      count
    }
  }
  total_per_type_po: waiting_list_aggregate(where: {type: {_eq: po}}) {
    aggregate {
      count
    }
  }
  total_per_type_ggo: waiting_list_aggregate(where: {type: {_eq: ggo}}) {
    aggregate {
      count
    }
  }
  total_per_type_reg: waiting_list_aggregate(where: {type: {_eq: reg}}) {
    aggregate {
      count
    }
  }
  total_per_type_bor: waiting_list_aggregate(where: {type: {_eq: bor}}) {
    aggregate {
      count
    }
  }
  total_per_type_isb: waiting_list_aggregate(where: {type: {_eq: isb}}) {
    aggregate {
      count
    }
  }
  total_per_region_ah: waiting_list_aggregate(where: {region: {_eq: "AH"}}) {
    aggregate {
      count
    }
  }
  total_per_region_zd: waiting_list_aggregate(where: {region: {_eq: "ZD"}}) {
    aggregate {
      count
    }
  }
  total_per_region_nv: waiting_list_aggregate(where: {region: {_eq: "NV"}}) {
    aggregate {
      count
    }
  }
  total_per_region_tw: waiting_list_aggregate(where: {region: {_eq: "TW"}}) {
    aggregate {
      count
    }
  }
  total_per_region_mo: waiting_list_aggregate(where: {region: {_eq: "MO"}}) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetWaitingListStatsPerDayQuery__
 *
 * To run a query within a React component, call `useGetWaitingListStatsPerDayQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWaitingListStatsPerDayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWaitingListStatsPerDayQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useGetWaitingListStatsPerDayQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetWaitingListStatsPerDayQuery, GetWaitingListStatsPerDayQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWaitingListStatsPerDayQuery, GetWaitingListStatsPerDayQueryVariables>(GetWaitingListStatsPerDayDocument, options);
      }
export function useGetWaitingListStatsPerDayLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetWaitingListStatsPerDayQuery, GetWaitingListStatsPerDayQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWaitingListStatsPerDayQuery, GetWaitingListStatsPerDayQueryVariables>(GetWaitingListStatsPerDayDocument, options);
        }
export type GetWaitingListStatsPerDayQueryHookResult = ReturnType<typeof useGetWaitingListStatsPerDayQuery>;
export type GetWaitingListStatsPerDayLazyQueryHookResult = ReturnType<typeof useGetWaitingListStatsPerDayLazyQuery>;
export type GetWaitingListStatsPerDayQueryResult = Apollo.QueryResult<GetWaitingListStatsPerDayQuery, GetWaitingListStatsPerDayQueryVariables>;
export const SeeAllClientsIdsInWaitingListDocument = gql`
    query SeeAllClientsIdsInWaitingList {
  waiting_list(where: {client_id: {_is_null: false}}) {
    waiting_list_waiting_list_items {
      caseload {
        client_id
        user_id
      }
      id
    }
    client_id
  }
}
    `;

/**
 * __useSeeAllClientsIdsInWaitingListQuery__
 *
 * To run a query within a React component, call `useSeeAllClientsIdsInWaitingListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSeeAllClientsIdsInWaitingListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSeeAllClientsIdsInWaitingListQuery({
 *   variables: {
 *   },
 * });
 */
export function useSeeAllClientsIdsInWaitingListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SeeAllClientsIdsInWaitingListQuery, SeeAllClientsIdsInWaitingListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SeeAllClientsIdsInWaitingListQuery, SeeAllClientsIdsInWaitingListQueryVariables>(SeeAllClientsIdsInWaitingListDocument, options);
      }
export function useSeeAllClientsIdsInWaitingListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SeeAllClientsIdsInWaitingListQuery, SeeAllClientsIdsInWaitingListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SeeAllClientsIdsInWaitingListQuery, SeeAllClientsIdsInWaitingListQueryVariables>(SeeAllClientsIdsInWaitingListDocument, options);
        }
export type SeeAllClientsIdsInWaitingListQueryHookResult = ReturnType<typeof useSeeAllClientsIdsInWaitingListQuery>;
export type SeeAllClientsIdsInWaitingListLazyQueryHookResult = ReturnType<typeof useSeeAllClientsIdsInWaitingListLazyQuery>;
export type SeeAllClientsIdsInWaitingListQueryResult = Apollo.QueryResult<SeeAllClientsIdsInWaitingListQuery, SeeAllClientsIdsInWaitingListQueryVariables>;